var unirest = require('unirest');

const apiv2 = process.env.REACT_APP_API_URL;


export async function getTeacherCourses ( token , personaID , calendarID) {
    const res =  await unirest.get(apiv2 + "teachers/courses" )
    .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function getCourseSubject ( token , courseSubjectID) {
    const res =  await unirest.get(apiv2 + "teachers/courses/"+courseSubjectID )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}



export async function getAllEvals ( token , courseSubjectID) {
    const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+ "/evals/all" )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseEvals ( token , courseSubjectID) {
    const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+ "/evals" )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseSubjectStudentsEvals ( token , courseSubjectID, personaID) {
    const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals" )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseSubjectStudents ( token , courseSubjectID) {
    const res =  await unirest.get(apiv2 + "subjects/"+courseSubjectID+"/students")
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}
// 


export async function deleteCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID ) {

    const res =  await unirest.delete(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals/"+evaluationID )
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data ) {

    const res =  await unirest.put(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals/"+evaluationID )
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
            .send(data)
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, 
                                                        qualifValueID, qualifValueNbr , comments ) {

    let data =  { qualif_value_id: qualifValueID, qualif_value_nbr: qualifValueNbr, comments: comments } ;

    const res =  await unirest.post(apiv2 + "subjects/"+courseSubjectID+"/"+personaID  + "/evals/" + evaluationID )
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
            .send(data)
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}